import * as React from 'react';
import classNames from 'classnames';
import { fetchIcon } from '../../services/icon';
import { DefaultIcon } from './DefaultIcon';
export class BadgeIcon extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            iconContent: '',
            hasLoadFailed: false,
        };
        this.isWixMediaManagerIcon = () => { var _a; return new URL((_a = this.props.badgeIcon) !== null && _a !== void 0 ? _a : '').hostname === BadgeIcon.WIX_STATICS_HOSTNAME; };
        this.fetchIcon = async () => {
            const { badgeIcon } = this.props;
            if (badgeIcon && this.isWixMediaManagerIcon()) {
                const newState = await fetchIcon(badgeIcon, this.props.httpClient);
                this.setState(newState);
            }
        };
        this.setIconRef = (element) => {
            this.iconRef = element;
        };
        this.setSvgAttributes = (svg) => {
            const bbox = svg.getBBox();
            const viewBox = [bbox.x, bbox.y, bbox.width, bbox.height].join(' ');
            svg.setAttribute('viewBox', viewBox);
            svg.setAttribute('width', `${bbox.width}px`);
            svg.setAttribute('height', `${bbox.height}px`);
        };
    }
    async componentDidMount() {
        await this.fetchIcon();
    }
    async componentDidUpdate(prevProps, prevState) {
        if (prevProps.badgeIcon !== this.props.badgeIcon) {
            await this.fetchIcon();
        }
        if (!this.iconRef) {
            return;
        }
        const svg = this.iconRef.getElementsByTagName('svg')[0];
        const isSvgAttached = svg && svg.parentNode && svg.parentNode.offsetParent;
        if (isSvgAttached) {
            this.setSvgAttributes(svg);
        }
        if (prevState.iconContent !== this.state.iconContent && this.props.onLoadIcon) {
            this.props.onLoadIcon();
        }
    }
    render() {
        const { size, layout, badgeIcon, hideDefaultIcon } = this.props;
        const iconClass = classNames('icon', size, layout);
        if (layout === 'name-only') {
            return null;
        }
        if (badgeIcon && !this.isWixMediaManagerIcon()) {
            return React.createElement("img", { className: iconClass, src: badgeIcon });
        }
        if (badgeIcon && !this.state.hasLoadFailed) {
            const innerHtml = { __html: this.state.iconContent };
            return React.createElement("div", { ref: this.setIconRef, className: iconClass, dangerouslySetInnerHTML: innerHtml });
        }
        if (layout !== 'icon-only') {
            return null;
        }
        if (!hideDefaultIcon) {
            return React.createElement(DefaultIcon, null);
        }
        return null;
    }
}
BadgeIcon.WIX_STATICS_HOSTNAME = 'static.wixstatic.com';
//# sourceMappingURL=BadgeIcon.js.map